<template>
  <v-container fluid>
    <PageTitle title="Test" />
    <v-card>
      <v-list>
        <v-list-item @click="ping">
          <v-list-item-avatar>
            <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Ping</v-list-item-title>
            <v-list-item-subtitle>No authentication</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="pingAuthen">
          <v-list-item-avatar>
            <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Ping with authentication</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="pingGuest">
          <v-list-item-avatar>
            <v-icon>mdi-arrow-right-drop-circle-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Ping with guest</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Test send mail.</v-list-item-title>
            <v-list-item-subtitle>
              <v-text-field
                filled
                hide-details
                v-model="mailFrom"
                label="From Address"
                class="mt-2"
              ></v-text-field>
              <v-text-field
                filled
                hide-details
                v-model="mailTo"
                label="To Address"
                class="mt-2"
              ></v-text-field>
              <v-btn outlined @click="sendMail" class="mt-4" color="primary"
                >Send Mail</v-btn
              >
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Test send message.</v-list-item-title>
            <v-list-item-subtitle>
              <v-text-field
                filled
                hide-details
                v-model="messageBody"
                label="Body"
                class="mt-2"
              ></v-text-field>
              <v-btn outlined @click="sendMessage" class="mt-4" color="primary"
                >Send Message</v-btn
              >
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Test send web event.</v-list-item-title>
            <v-list-item-subtitle>
              <v-text-field
                filled
                hide-details
                v-model="eventName"
                label="Event Name"
                class="mt-2"
              ></v-text-field>
              <v-simple-table class="mt-4">
                <template>
                  <thead>
                    <tr>
                      <th>
                        <v-btn
                          color="primary"
                          text
                          @click="eventData.push({ name: '', value: '' })"
                        >
                          <v-icon class="mr-2">mdi-plus</v-icon>Add Parameter
                        </v-btn>
                      </th>
                      <th></th>
                      <th style="width: 30px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in eventData" :key="index">
                      <td>
                        <v-text-field
                          filled
                          hide-details
                          label="Parameter Name"
                          v-model="item.name"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          filled
                          hide-details
                          label="Parameter Value"
                          v-model="item.value"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-btn
                          icon
                          color="error"
                          title="Delete Parameter"
                          @click="eventData.splice(index, 1)"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn outlined @click="sendWebEvent" class="mt-4" color="primary"
                >Send Web Event</v-btn
              >
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>

    <v-dialog v-model="dialog" scrollable width="800">
      <v-card>
        <v-card-title>Result</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <th>NAME</th>
                  <th>VALUE</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in result" :key="index">
                  <td v-if="item.name == 'claims'" colspan="2" class="pa-0">
                    <v-simple-table>
                      <template>
                        <thead>
                          <tr>
                            <th>CLAIMS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(claim, claimIndex) in item.value"
                            :key="claimIndex"
                          >
                            <td>{{ claim }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </td>
                  <td v-if="item.name != 'claims'">{{ item.name }}</td>
                  <td v-if="item.name != 'claims'">{{ item.value }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import http from "../../services/http.js";
import server from "../../services/server.js";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "Test",

  components: { PageTitle },

  data() {
    return {
      dialog: false,
      result: [],
      mailFrom: "",
      mailTo: "",
      messageBody: "",
      eventName: "",
      eventData: [],
    };
  },

  methods: {
    ping() {
      http
        .get(process.env.VUE_APP_SERVER + "api/test/check")
        .then((response) => {
          this.showResult(response);
        })
        .catch((err) => {
          this.showResult(err);
        });
    },
    pingAuthen() {
      server
        .get("test/check/user")
        .then((response) => {
          this.showResult(response);
        })
        .catch((err) => {
          this.showResult(err);
        });
    },
    pingGuest() {
      http
        .get(process.env.VUE_APP_SERVER + "api/test/check/guest")
        .then((response) => {
          this.showResult(response);
        })
        .catch((err) => {
          this.showResult(err);
        });
    },
    sendMail() {
      if (this.mailFrom && this.mailTo) {
        server
          .get("test/sendmail?from=" + this.mailFrom + "&to=" + this.mailTo)
          .then((response) => {
            this.showResult(response);
          })
          .catch((err) => {
            this.showResult(err);
          });
      } else {
        alert("Please input from and to addresses!");
      }
    },
    sendMessage() {
      if (this.messageBody) {
        server
          .post("test/sendmessage", { body: this.messageBody })
          .then((result) => this.showResult(result))
          .catch((err) => this.showResult(err));
      } else {
        alert("Please input message's body!");
      }
    },
    sendWebEvent() {
      if (this.eventName) {
        server
          .post("test/sendevent", {
            name: this.eventName,
            data: this.eventData,
          })
          .then((result) => this.showResult(result))
          .catch((err) => this.showResult(err));
      } else {
        alert("Please input event's name!");
      }
    },
    showResult(result) {
      this.result = [];

      if (result) {
        for (const key in result) {
          this.result.push({
            name: key,
            value: result[key],
          });
        }
      }

      this.dialog = true;
    },
  },
};
</script>
